import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    clientInput: {
        paddingLeft: theme.typography.pxToRem(9),
        marginTop: 8
    }
}));
